"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const Slide_vue_1 = tslib_1.__importDefault(require("../Slide.vue"));
const SyncFailure_vue_1 = tslib_1.__importDefault(require("../SyncFailure.vue"));
exports.default = vue_1.default.extend({
    name: 'check-sync-result',
    props: {},
    computed: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
    },
    components: {
        IsotopeSlide: Slide_vue_1.default,
        SyncFailure: SyncFailure_vue_1.default,
    },
});
